// extracted by mini-css-extract-plugin
export default {"wrapper":"ContentfulBreakoutBanner-module__wrapper--PQ_KP","logoWrapper":"ContentfulBreakoutBanner-module__logoWrapper--ngeuj"};